var map = {
	"./components/details_controller.js": 6604,
	"./components/gallery_controller.js": 972,
	"./components/highlight_controller.js": 9066,
	"./components/highlight_gallery_controller.js": 3955,
	"./components/news_and_events_controller.js": 9175,
	"./components/power_bi_controller.js": 5555,
	"./components/slider_controller.js": 9032,
	"./components/slider_split_controller.js": 4866,
	"./components/testimonials_controller.js": 7359,
	"./components/text_controller.js": 6186,
	"./components/video_controller.js": 1740
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2204;